import { $FixingSystem } from '../__generated/enhanced-model.js';
import { FinishType, FixingSystemAttachementType, FixingSystemPositionType, FixingSystemType, PositionType, PostShapeType } from '../__generated/model/index.js';
import { DataBindingBuilder, ExpressionBindingBuilder } from '../sdk/data-binding.js';
import { Materials } from './materials.js';
import { ObjectNames } from './objects.js';
const fixingSystemPositionType = DataBindingBuilder.from('fixingSystemPositionType', $FixingSystem, [
    'leftPositionType',
    'rightPositionType'
], [
    {
        keys: {
            leftPositionType: [
                PositionType.LeftEnd,
                PositionType.MidPost,
                PositionType.FlatFlatRight,
                PositionType.FlatFlatAcuteLeft,
                PositionType.FlatFlatObtuse,
                PositionType.StairsFlatOtherTopRight,
                PositionType.StairsFlatOtherBottomLeft,
                PositionType.FlatStairsStraightBottomLeft,
                PositionType.FlatStairsStraightTopRight,
                PositionType.FlatStairsCornerBottomLeft,
                PositionType.FlatStairsCornerTopRight,
                PositionType.FlatStairsOtherBottomLeft,
                PositionType.FlatStairsOtherTopRight
            ],
            rightPositionType: [
                PositionType.RightEnd,
                PositionType.MidPost,
                PositionType.FlatFlatRight,
                PositionType.FlatFlatAcuteRight,
                PositionType.FlatFlatObtuse,
                PositionType.StairsFlatOtherTopRight,
                PositionType.StairsFlatOtherBottomLeft,
                PositionType.FlatStairsStraightTopLeft,
                PositionType.FlatStairsStraightBottomRight,
                PositionType.FlatStairsCornerTopLeft,
                PositionType.FlatStairsCornerBottomRight,
                PositionType.FlatStairsOtherTopLeft,
                PositionType.FlatStairsOtherBottomRight
            ]
        },
        values: {
            fixingSystemPositionType: FixingSystemPositionType.Flat
        }
    },
    {
        keys: {
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.FlatFlatObtuse
        },
        values: {
            fixingSystemPositionType: FixingSystemPositionType.Obtuse
        }
    },
    {
        keys: {
            leftPositionType: [
                PositionType.StairsTopLeftEnd,
                PositionType.StairsBottomRightEnd,
                PositionType.FlatStairsStraightTopLeft,
                PositionType.FlatStairsStraightBottomRight,
                PositionType.FlatStairsCornerTopLeft,
                PositionType.FlatStairsCornerBottomRight,
                PositionType.FlatStairsOtherTopLeft,
                PositionType.FlatStairsOtherBottomRight,
                PositionType.StairsFlatOtherTopLeft,
                PositionType.StairsFlatOtherBottomRight
            ],
            rightPositionType: [
                PositionType.StairsBottomLeftEnd,
                PositionType.StairsTopRightEnd,
                PositionType.FlatStairsStraightBottomLeft,
                PositionType.FlatStairsStraightTopRight,
                PositionType.FlatStairsCornerBottomLeft,
                PositionType.FlatStairsCornerTopRight,
                PositionType.FlatStairsOtherBottomLeft,
                PositionType.FlatStairsOtherTopRight,
                PositionType.StairsFlatOtherBottomLeft,
                PositionType.StairsFlatOtherTopRight
            ]
        },
        values: {
            fixingSystemPositionType: FixingSystemPositionType.Stairs
        }
    }
]);
const fixingSystemAttachementData = DataBindingBuilder.from('test', $FixingSystem, [
    '$fixingSystemType',
    '$finishType',
    '$fixingSystemPositionType',
    '$postShape'
], [
    // #region Fork With Saddles - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Fork With Saddles - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkTimberHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Fork With Screw Eyes - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Fork With Screw Eyes - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ForkWithScrewEyes,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSE',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 6,
            fixingSystemObjectName: ObjectNames.wireRigForkScrewEye,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Timber Insert - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-TIS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-TIS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-TIS',
                'S03',
                'S03',
                'SS-7813R-0615'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareAdaptor
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-TIS',
                'S03',
                'S03',
                'SS-7813L-0615',
                'SS-7813R-0615'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsAdaptor
        }
    },
    // #endregion
    // #region Timber Insert - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TIS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TIS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TIS',
                'S03',
                'S03',
                'BS-7813R-0615'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareAdaptor
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.TimberInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TIS',
                'S03',
                'S03',
                'BS-7813L-0615',
                'BS-7813R-0615'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireInsertTimberScrew,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsAdaptor
        }
    },
    // #endregion
    // #region Toggle Lock - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsRotated
        }
    },
    // #endregion
    // #region Toggle Lock - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.ToggleLock,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-TLS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: -5,
            fixingSystemObjectName: ObjectNames.wireFlipLockInsert,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsRotated
        }
    },
    // #endregion
    // #region Metal Insert - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-MIS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-MIS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-MIS',
                'S03',
                'S03',
                'SS-7813R-0615'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareAdaptor
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-MIS',
                'S03',
                'S03',
                'SS-7813L-0615',
                'SS-7813R-0615'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsAdaptor
        }
    },
    // #endregion
    // #region Metal Insert - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-MIS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-MIS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-MIS',
                'S03',
                'S03',
                'BS-7813R-0615'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareAdaptor
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.MetalInsert,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-MIS',
                'S03',
                'S03',
                'BS-7813L-0615',
                'BS-7813R-0615'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 0,
            fixingSystemObjectName: ObjectNames.wireInsertMetalRivet,
            wireObjectName: ObjectNames.wireInsertWire,
            scaleZero: 179 - 11.2,
            scaleOne: 10029.3 - 11.2,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsAdaptor
        }
    },
    // #endregion
    // #region Rig Fork With Nutserts - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Rig Fork With Nutserts - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithNutserts,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFNS',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 16,
            fixingSystemObjectName: ObjectNames.wireRigForkNutRivet,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Rig Fork With Saddles - Bright
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.Bright,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBS-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'WRS119316-032-MTR',
            material: Materials.MetalBright,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    },
    // #endregion
    // #region Rig Fork With Saddles - Black Etch
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Flat,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.Flat
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: [
                PostShapeType.Round,
                PostShapeType.Custom
            ]
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Obtuse,
            $postShape: PostShapeType.Square
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        }
    },
    {
        keys: {
            $fixingSystemType: FixingSystemType.RigForkWithSaddles,
            $finishType: FinishType.BlackEtch,
            $fixingSystemPositionType: FixingSystemPositionType.Stairs,
            $postShape: PostShapeType.values()
        },
        values: {
            fixingSystemSkus: [
                'WBSB-RFSAD-M',
                'S03',
                'S03'
            ],
            wireSku: 'BWRS119316-032-MTR',
            material: Materials.MetalBlackEtch,
            partCenterOffset: 11,
            fixingSystemObjectName: ObjectNames.wireRigForkMetalHook,
            wireObjectName: ObjectNames.wireRigForkWire,
            scaleZero: 256 - 12,
            scaleOne: 10012 - 12,
            fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        }
    }
]);
const parts = ExpressionBindingBuilder.from('partObjects', $FixingSystem, [
    '$fixingSystemAttachementType'
], [
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.Flat
        },
        values: {
            value: '$flatParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.ObtuseRound
        },
        values: {
            value: '$obtuseRoundParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareRotated
        },
        values: {
            value: '$obtuseSquareRotatedParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.ObtuseSquareAdaptor
        },
        values: {
            value: '$obtuseSquareAdaptorParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.StairsSimple
        },
        values: {
            value: '$stairsSimpleParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.StairsRotated
        },
        values: {
            value: '$stairsRotatedParts'
        }
    },
    {
        keys: {
            $fixingSystemAttachementType: FixingSystemAttachementType.StairsAdaptor
        },
        values: {
            value: '$stairsAdaptorParts'
        }
    }
]);
export const FixingSystemDataBindings = {
    parts,
    fixingSystemPositionType,
    fixingSystemAttachementData
};

//# sourceMappingURL=fixing-system.js.map